import * as React from "react";
import PageContainer from "../core/PageContainer";
import Breadcrumbs from "../core/Breadcrumbs";
import { wrapComponentForErrors } from "../utility/ErrorHandler";
import CourseUsers from "../report/CourseUsers";
import CourseLessons from "../report/CourseLessons";
import Card from "../core/Card";
import {XYPlot, VerticalGridLines, HorizontalGridLines, VerticalBarSeries, XAxis, YAxis} from 'react-vis';
import CourseViewsChart from "../report/CourseViewsChart";
import CourseEnrollementChart from "../report/CourseEnrollementChart";

interface IProps {
  course: any;
  userContext: IUserContextData;
  lessons: any;
}

interface IState {
}

class Reports extends React.Component<IProps, IState> {

  render() {
    const { course, lessons } = this.props;
    return (
      <PageContainer>
        <Breadcrumbs crumbs={[
          { label: "Courses", route: "/library/courses" },
          { label: `Report: ${course.title}` }
          ]} />
        <Card title={`REPORT: ${course.title}`}>
          <div className="columns">
            <div className="column is-6"><CourseViewsChart/></div>
            <div className="column is-6"><CourseEnrollementChart/></div>
          </div>
          <CourseLessons lessons={lessons}/>
          <CourseUsers course={course}/>
        </Card>
      </PageContainer>
    );
  }
}

export default wrapComponentForErrors(Reports);



// WEBPACK FOOTER //
// ./app/javascript/components/pages/Reports.tsx